import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { SubmitTrainingItemEvaluationCommand } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const educationalAdvisorSubmitTrainingItemEvaluation = createApiThunk<void, SubmitTrainingItemEvaluationCommand>(
  "educationalAdvisor/submitTrainingItemEvaluation",
  async (command, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.submitTrainingItemEvaluation(command);
  },
);

export const resetEducationalAdvisorSubmitTrainingItemEvaluation = createAction("educationalAdvisor/resetSubmitTrainingItemEvaluation");
